import { LogoIcon } from 'assets';
import { colors } from 'styles/colors';

const About4um = () => {
return (
    <div style={{textAlign:'justify', padding: '0 5px'}}>
      <div style={{ padding: "15px", textAlign: "center" }}>
      <LogoIcon></LogoIcon>
      </div>
      <p
        style={{
          textAlign: "justify",
          height:'200px'
        }}
      >
        4um is a Social Media Platform that will provide Users with the Ability
        to Post Pictures and Videos in order to connect with other like-minded
        individuals. 4um will be the Anchor for a Conglomerate of Social Media
        Websites that will combine to form a Social Media SuperApp.
      </p>
    </div>
  );
};

export default About4um;
